import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField'
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions'
import { getProjects, saveProject, deleteProject } from '../../actions/dbFunctionsActions'
import CloseIcon from '@mui/icons-material/Close';

class AddEditProject extends React.Component {

    state = {
        projectId: -1,
        projectName: "",
        projectDescription: "",
        customerID: "",
        projectList: [],
        selectedTeamIds: [],
        saveStatus: "",
        saveOperation: "",
        showConfirm: false
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Pre-select Builder's teams on mount
        if (this.props.role === "Builder" && this.props.currentUser) {
            const builderTeamIds = this.getBuilderTeamIds()
            this.setState({ selectedTeamIds: builderTeamIds })
        }

        getProjects().then(json => {
            this.setState({ projectList: json.projectList || [] })
        })
            .catch(ex => {
                console.error('Failed to load projects', ex)
                this.setState({ projectList: [] })
            })
    }

    getBuilderTeamIds = () => {
        const currentUser = this.props.currentUser
        if (!currentUser) return []

        const teams = (this.props.teamList || [])
            .filter(x => x.customer.id === parseInt(currentUser.customerID))
            .sort((a, b) => parseFloat(a.id) - parseFloat(b.id))

        let allTeamIds = []
        for (let allTeamIndex = 0; allTeamIndex < teams.length; allTeamIndex++) {
            for (let userTeamIndex = 0; userTeamIndex < currentUser.applicationUserTeams.length; userTeamIndex++) {
                if (teams[allTeamIndex]["id"] === currentUser.applicationUserTeams[userTeamIndex]["teamID"]) {
                    allTeamIds.push(currentUser.applicationUserTeams[userTeamIndex]["teamID"])
                }
            }
        }
        return allTeamIds
    }

    handleSave = (event) => {
        event.preventDefault()

        if (!this.state.projectName.trim()) {
            this.setState({ saveStatus: 'Project name cannot be empty.', saveOperation: 'save' })
            return
        }

        if (this.state.selectedTeamIds.length === 0) {
            this.setState({ saveStatus: 'At least one team must be selected.', saveOperation: 'save' })
            return
        }

        const project = {
            Id: this.state.projectId,
            ProjectName: this.state.projectName,
            ProjectDescription: this.state.projectDescription,
            TeamIds: this.state.selectedTeamIds
        }

        saveProject(project)
            .then(resp => {
                this.setState({ saveStatus: 'success', saveOperation: 'save' })
                setTimeout(() => {
                    this.props.closePopup()
                }, 2000)
            })
            .catch(ex => {
                console.error('Failed to save project', ex)
                this.setState({ saveStatus: ex.message, saveOperation: 'save' })
            })
    }

    handleDeleteConfirmed = () => {
        this.setState({ showConfirm: false })

        deleteProject(this.state.projectId)
            .then(resp => {
                this.setState({ saveStatus: 'success', saveOperation: 'delete' })
                setTimeout(() => {
                    this.props.closePopup()
                }, 2000)
            })
            .catch(ex => {
                console.error('Failed to delete project', ex)
                this.setState({ saveStatus: ex.message, saveOperation: 'delete' })
            })
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    populateProjects = () => {
        return (
            <Select
                className="myInput"
                onChange={(e) => {
                    const selectedId = parseInt(e.target.value)
                    const project = this.state.projectList.find(p => p.id === selectedId) || null

                    const newTeamIds = selectedId === -1 && this.props.role === "Builder"
                        ? this.getBuilderTeamIds()
                        : project?.projectTeams?.map(t => parseInt(t.teamID)) || []

                
                    this.setState({
                        projectId: selectedId,
                        projectName: project?.projectName || "",
                        projectDescription: project?.projectDesc || "",
                        selectedTeamIds: newTeamIds,
                        saveStatus: ""
                    })
                }}
                value={this.state.projectId}
                inputProps={{ 'aria-label': 'Without label' }}
            >
                <MenuItem value={-1}>New Project</MenuItem>
                {this.state.projectList.length > 0 ? this.state.projectList.map((x) => <MenuItem key={x.id} value={x.id}>{x.projectName}</MenuItem>) : null}
            </Select>
        )
    }

    populateTeams = () => {
        const currentUser = this.props.currentUser
        if (!currentUser) return null

        const isBuilder = this.props.role === "Builder"
        const isNewProject = this.state.projectId === -1
        const checkboxDisabled = isBuilder && !isNewProject

        let teams = (this.props.teamList || [])
            .filter(x => x.customer.id === parseInt(currentUser.customerID))
            .sort((a, b) => parseFloat(a.id) - parseFloat(b.id))

        if (isBuilder) {
            let filteredTeams = []
            for (let allTeamIndex = 0; allTeamIndex < teams.length; allTeamIndex++) {
                for (let userTeamIndex = 0; userTeamIndex < currentUser.applicationUserTeams.length; userTeamIndex++) {
                    if (teams[allTeamIndex]["id"] === currentUser.applicationUserTeams[userTeamIndex]["teamID"]) {
                        filteredTeams.push(teams[allTeamIndex])
                    }
                }
            }
            teams = filteredTeams
        }

        if (teams.length === 0) return null

        return (
            <div className="field">
                <FormLabel component="legend">This project will be available to the following teams</FormLabel>
                {teams.map((x, i) => (
                    <FormControlLabel
                        key={`team-${i}`}
                        label={x.name}
                        control={
                            <Checkbox
                                checked={this.state.selectedTeamIds.includes(x.id)}
                                disabled={checkboxDisabled}
                                onChange={(e) => {
                                    if (checkboxDisabled) return
                                    let copiedTeamIds = [...this.state.selectedTeamIds]

                                    if (e.target.checked) {
                                        copiedTeamIds.push(x.id)
                                    } else {
                                        const index = copiedTeamIds.indexOf(x.id)
                                        if (index > -1) copiedTeamIds.splice(index, 1)
                                    }

                                    this.setState({ selectedTeamIds: copiedTeamIds })
                                }}
                            />
                        }>
                    </FormControlLabel>
                ))}
            </div>
        )
    }

    render() {
        const isNewProject = this.state.projectId === -1

        return (
            <>
                <Dialog
                    open={true}
                    onClose={this.handleClick}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <CloseIcon onClick={this.handleClick} className="closePoup" />
                    <DialogTitle id="alert-dialog-title" className="changepassdialog">
                        Projects
                    </DialogTitle>
                    <DialogContent>
                        <form className="form">
                            {this.populateProjects()}
                            {this.populateTeams()}
                            <br />

                            <div className="field">
                                <TextField
                                    fullWidth
                                    label="Project Name"
                                    variant="outlined"
                                    value={this.state.projectName}
                                    disabled={false}
                                    onChange={(e) => this.setState({ projectName: e.target.value })}
                                    required
                                />
                            </div>
                            <br />
                            <div className="field">
                                <TextField
                                    fullWidth
                                    label="Project Description"
                                    variant="outlined"
                                    value={this.state.projectDescription}
                                    disabled={false}
                                    onChange={(e) => this.setState({ projectDescription: e.target.value })}
                                    multiline
                                    rows={5}
                                />
                            </div>
                            <br />
                            {this.state.saveStatus && (
                                <div style={{
                                    color: this.state.saveStatus === 'success' ? '#2e7d32' : '#d32f2f',
                                    marginTop: '8px',
                                    fontSize: '1rem'
                                }}>
                                    {this.state.saveStatus === 'success'
                                        ? this.state.saveOperation === 'delete'
                                            ? '✓ Project deleted successfully.'
                                            : '✓ Project saved successfully.'
                                        : this.state.saveOperation === 'delete'
                                            ? `✗ Failed to delete project. ${this.state.saveStatus}`
                                            : `✗ Failed to save project. ${this.state.saveStatus}`}
                                </div>
                            )}

                            <br />
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                <button
                                    className="btn"
                                    type="button"
                                    id="delete_btn"
                                    style={{
                                        backgroundColor: isNewProject ? '#9e9e9e' : '#d32f2f',
                                        color: '#fff',
                                        cursor: isNewProject ? 'not-allowed' : 'pointer'
                                    }}
                                    disabled={isNewProject}
                                    onClick={() => this.setState({ showConfirm: true })}
                                >
                                    Delete
                                </button>
                                <button className="btn" type="button" id="save_btn" onClick={this.handleSave}>
                                    {isNewProject ? 'Add New' : 'Update'}
                                </button>
                            </div>
                        </form>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.state.showConfirm}
                    onClose={() => this.setState({ showConfirm: false })}
                    aria-labelledby="confirm-dialog-title"
                >
                    <DialogTitle id="confirm-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Deleting a project deletes all its jobs, files and history. Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn" type="button" onClick={() => this.setState({ showConfirm: false })}>
                            Cancel
                        </button>
                        <button
                            className="btn"
                            type="button"
                            style={{ backgroundColor: '#d32f2f', color: '#fff' }}
                            onClick={this.handleDeleteConfirmed}
                        >
                            Delete
                        </button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.users,
        role: state.users.role,
        popupInfo: state.ui.popupInfo,
        teamList: state.users.teamList,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditProject)